import { render, staticRenderFns } from "./SeparateTrustees.vue?vue&type=template&id=88b2e4d6"
import script from "./SeparateTrustees.vue?vue&type=script&lang=js"
export * from "./SeparateTrustees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports